export const API_BASE_URL = 'http://localhost:3000/api';
// publicRoutes
export const WELCOME_PAGE_ROUTE = '/';
export const SIGN_UP_ROUTE = '/signup';
export const SIGN_IN_ROUTE = '/signin';
// privateRoutes
export const DIARY_ROUTE = '/diary';
export const PRODUCTS_ROUTE = '/products';
export const EXERCISES_ROUTE = '/exercises';
export const PROFILE_ROUTE = '/profile';

// BackEnd routes

export const BACKEND_API_BASE_URL = 'http://localhost:5000/api';

export const BACKEND_SIGN_UP_ROUTE = '/api/users/signup';
export const BACKEND_SIGN_IN_ROUTE = '/api/users/signin';
export const BACKEND_SIGN_OUT_ROUTE = '/api/users/signout';
export const BACKEND_REFRESH_ROUTE = '/api/users/current';
export const BACKEND_AVATAR_ROUTE = '/api/users/avatars';
export const BACKEND_PROFILE_SETTINGS_ROUTE = '/api/profile-settings';
export const BACKEND_EXERCISES_ROUTE = '/api/exercises';
export const BACKEND_EXERCISES_CATEGORY_ROUTE = '/api/exercises/categories';
export const BACKEND_PRODUCTS_ROUTE = '/api/products';
export const BACKEND_PRODUCTS_CATEGORY_ROUTE = '/api/products/categories';
